var map = {
	"./Banayeni.png": "1b22",
	"./Ciceksepeti.png": "ba929",
	"./Hepsiburada.png": "f180",
	"./Ikas.png": "0b02",
	"./Modanisa.png": "16e1",
	"./N11.png": "4f2d",
	"./Pazarama.png": "b1bb",
	"./PttAvm.png": "2252",
	"./Shopify.png": "1f79",
	"./Ticimax.png": "8dc0",
	"./Toptan.png": "f2fc",
	"./Trendyol.png": "f801",
	"./Tsoft.png": "a004",
	"./favicon.png": "6d55",
	"./logo.png": "a4ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";